import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LocalChannelState } from '../reducers';

export const selectLocalChannelState = createFeatureSelector<LocalChannelState>('localChannel');

export const selectLocalChannelLoading = createSelector(selectLocalChannelState,(state: LocalChannelState) => state.loading);

export const selectLocalChannelId = createSelector(selectLocalChannelState,(state: LocalChannelState) => state.localChannelId);

export const selectLocalChannel = createSelector(selectLocalChannelState,(state: LocalChannelState) => state.localChannel);

export const selectLocalChannelError = createSelector(selectLocalChannelState,(state: LocalChannelState) => state.error);

export const selectLocalChannelSesion = createSelector(selectLocalChannelState,(state: LocalChannelState) => state.sesion);
